var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tab-title"},[_c('span',{staticClass:"title"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_c('span',{staticClass:"date"},[_vm._v("\n      "+_vm._s(_vm.tabDate)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }